export enum NavItem {
    Menu,
    Search,
}
